import styled from 'styled-components';
import { Color, Spacing, media } from '../../../../../theme';
const rowHeight = '2.5rem';
export const DataTableHeader = styled('thead') `
  th:not(:last-child) {
    border-right: 1px solid ${Color.GRAY_300};
  }

  ${media.down('sm') `
    /* Hide table headers (but not display: none;, for accessibility) */
    tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }
  `}
`;
export const DataTableHeading = styled('th') `
  padding: 0.5rem;
  ${(props) => props.theme.fonts.foundations.desktop.body}
  vertical-align: bottom;
  background-color: ${(props) => props.theme.colors.gray200 || Color.GRAY_200};
  cursor: ${(props) => (props.isSortable ? `pointer` : `default`)};

  ${(props) => media.up('sm') `
    min-height: ${rowHeight};
    text-align: ${props.align ? props.align : 'left'};
    width: ${props.width ? props.width : 'auto'};
    border-bottom: 1px solid ${Color.GRAY_300};
  `}
`;
export const DataTableHeadingTitle = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;

  svg {
    margin-left: ${Spacing.XS};
    height: 1.5rem;
    width: 1.5rem;
  }
`;
//# sourceMappingURL=data-table-head.styles.js.map